var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFiles(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 200,
    height: 181,
    viewBox: "0 0 200 181",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.236 0.910156L199.987 31.8169C199.987 31.8169 201.793 105.37 162.544 152.329C117.035 137.355 66.4687 120.584 66.4687 120.584C66.4687 120.584 100.781 84.1666 105.236 0.910156Z",
    fill: "#DFE6E5"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.261,
    y: 31.8838,
    width: 64.1887,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 117.261 31.8838)",
    fill: "#CAD1D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 115.185,
    y: 38.3564,
    width: 36.6535,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 115.185 38.3564)",
    fill: "#CAD1D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 168.537,
    y: 38.7412,
    width: 12.9237,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 168.537 38.7412)",
    fill: "#CAD1D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 152.722,
    y: 33.9268,
    width: 12.9237,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 152.722 33.9268)",
    fill: "#CAD1D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 112.875,
    y: 49.8652,
    width: 36.6535,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 112.875 49.8652)",
    fill: "#CAD1D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 109.459,
    y: 61.25,
    width: 36.6535,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 109.459 61.25)",
    fill: "#CAD1D3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M39.1735 29.0811L133.925 59.9878C133.925 59.9878 135.731 133.541 96.4817 180.5C50.9723 165.526 0.406204 148.755 0.406204 148.755C0.406204 148.755 34.7189 112.337 39.1735 29.0811Z",
    fill: "#ECF2F1"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 51.5288,
    y: 60.0547,
    width: 64.1887,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 51.5288 60.0547)",
    fill: "#CAD1D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 49.4526,
    y: 66.5273,
    width: 36.6535,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 49.4526 66.5273)",
    fill: "#CAD1D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 102.804,
    y: 66.9121,
    width: 12.9237,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 102.804 66.9121)",
    fill: "#CAD1D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 86.9897,
    y: 62.0977,
    width: 12.9237,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 86.9897 62.0977)",
    fill: "#CAD1D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 47.1426,
    y: 78.0361,
    width: 36.6535,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 47.1426 78.0361)",
    fill: "#CAD1D3"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 43.7271,
    y: 89.4209,
    width: 36.6535,
    height: 3.7413,
    rx: 1.87065,
    transform: "rotate(17.389 43.7271 89.4209)",
    fill: "#CAD1D3"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFiles);
export default __webpack_public_path__ + "static/media/files.8edb9b81f3c19753708931b7f5a69728.svg";
export { ForwardRef as ReactComponent };